import React, { useState } from 'react';
import { useAuth } from './AuthProvider';
import {
  Button,
  Spinner,
  Input,
  FormLabel,
  Alert,
  AlertTitle,
  AlertDescription,
} from './components/ui';

const Login = () => {
  const [error, setError] = useState('');
  const [inviteeEmail, setInviteeEmail] = useState('');
  const [inviteePassword, setInviteePassword] = useState('');
  const { loginWithGoogle, loginWithEmailPassword, authLoading } = useAuth();

  const handleGoogleLogin = async () => {
    try {
      setError('');
      const result = await loginWithGoogle();
      if (!result.success) {
        setError(result.error);
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    }
  };

  const handleInviteeLogin = async (e) => {
    e.preventDefault();
    const email = inviteeEmail.trim();
    const password = inviteePassword;
    if (!email || !password) {
      setError('Please enter email and password.');
      return;
    }
    setError('');
    const result = await loginWithEmailPassword(email, password);
    if (!result.success) {
      setError(result.error);
    }
  };

  return (
    <div className="bg-background text-foreground min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-lg border border-border bg-card rounded-lg shadow-subtle-sm p-8">
        <div className="text-center mb-8">
          <h1 className="text-foreground text-4xl font-bold mb-2">yirum</h1>
          <p className="text-muted-foreground text-base">Restricted Access</p>
        </div>

        <div className="space-y-6">
          {error && (
            <Alert variant="destructive">
              <AlertTitle>Sign in failed</AlertTitle>
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}

          <Button
            variant="default"
            size="lg"
            className="w-full"
            onClick={handleGoogleLogin}
            disabled={authLoading}
          >
            {authLoading ? (
              <>
                <Spinner size="md" className="mr-3 [&_svg]:text-background" />
                <span>Authenticating...</span>
              </>
            ) : (
              <>
                <svg className="w-5 h-5 shrink-0" viewBox="0 0 24 24" aria-hidden>
                  <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                  <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                  <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                  <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                </svg>
                <span className="ml-2">Sign in with Google</span>
              </>
            )}
          </Button>

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-border" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="bg-card px-2 text-muted-foreground">or</span>
            </div>
          </div>

          <div className="border border-border bg-surface rounded-lg p-4">
            <p className="text-foreground text-sm font-semibold mb-1">Invitee access only</p>
            <p className="text-muted-foreground text-xs mb-4">Use the email and temporary password shared with you by an admin.</p>
            <form onSubmit={handleInviteeLogin} className="space-y-4">
              <div>
                <FormLabel label="Email" />
                <Input
                  id="invitee-email"
                  type="email"
                  value={inviteeEmail}
                  onChange={(e) => setInviteeEmail(e.target.value)}
                  placeholder="you@example.com"
                  className="mt-2"
                  disabled={authLoading}
                  autoComplete="email"
                />
              </div>
              <div>
                <FormLabel label="Password" />
                <Input
                  id="invitee-password"
                  type="password"
                  value={inviteePassword}
                  onChange={(e) => setInviteePassword(e.target.value)}
                  placeholder="Password"
                  className="mt-2"
                  disabled={authLoading}
                  autoComplete="current-password"
                />
              </div>
              <Button type="submit" variant="outlined" size="md" className="w-full" disabled={authLoading}>
                {authLoading ? <Spinner size="sm" /> : 'Sign in with email'}
              </Button>
            </form>
          </div>

          <div className="text-center text-sm text-muted-foreground space-y-1">
            <p>Only @cultureflipper.com user can use Google.</p>
            <p>Contact Engineering if you need access.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
